var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1157 2.3942C16.6715 1.95003 15.9023 2.25337 15.9023 2.87087V6.6517C15.9023 8.23337 17.2457 9.5442 18.8815 9.5442C19.9107 9.55503 21.3407 9.55503 22.5648 9.55503C23.1823 9.55503 23.5073 8.8292 23.074 8.39587C21.514 6.82503 18.719 3.99753 17.1157 2.3942Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.207 11.0391H19.0762C16.5087 11.0391 14.4179 8.94829 14.4179 6.38079V3.24996C14.4179 2.65413 13.9304 2.16663 13.3345 2.16663H8.7412C5.40453 2.16663 2.70703 4.33329 2.70703 8.20079V17.7991C2.70703 21.6666 5.40453 23.8333 8.7412 23.8333H17.2562C20.5929 23.8333 23.2904 21.6666 23.2904 17.7991V12.1225C23.2904 11.5266 22.8029 11.0391 22.207 11.0391ZM12.457 19.2291H8.1237C7.67953 19.2291 7.3112 18.8608 7.3112 18.4166C7.3112 17.9725 7.67953 17.6041 8.1237 17.6041H12.457C12.9012 17.6041 13.2695 17.9725 13.2695 18.4166C13.2695 18.8608 12.9012 19.2291 12.457 19.2291ZM14.6237 14.8958H8.1237C7.67953 14.8958 7.3112 14.5275 7.3112 14.0833C7.3112 13.6391 7.67953 13.2708 8.1237 13.2708H14.6237C15.0679 13.2708 15.4362 13.6391 15.4362 14.0833C15.4362 14.5275 15.0679 14.8958 14.6237 14.8958Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/document-text.c1ae5bbef00ad9dd1b78d161744a739a.svg";
export { ForwardRef as ReactComponent };